import { h, Component } from 'preact'
import Search from './Search'

interface Props {
  isUserGuest: boolean
  isFederatedSalesforceSearch: boolean
  isFederatedSkilljarSearch: boolean
  isFederatedFreshdeskSearch: boolean
  displayFilters?: boolean
}

function getContentType () {
  if (typeof window === 'undefined') return undefined
  if (window.location.pathname.match(/^\/ideas/)) {
    return ['ideation']
  }
  if (window.location.pathname.match(/^\/product-updates/)) {
    return ['productUpdate']
  }
  return undefined
}

function getCategoryId () {
  if (typeof window === 'undefined') return null
  return window.inSidedData.content.category.id
}

export default class SearchForm extends Component<Props> {
  render ({
    isUserGuest,
    isFederatedSkilljarSearch,
    isFederatedSalesforceSearch,
    isFederatedFreshdeskSearch,
    displayFilters
  }: Props) {
    return (
      <form method='get' action='/search/index'>
        <div className='searchbox searchbox--large qa-search-area'>
          <div className='searchbox__input algolia-search--forum qa-menu-search-input'>
            <Search
              isUserGuest={isUserGuest}
              isFederatedSalesforceSearch={isFederatedSalesforceSearch}
              isFederatedSkilljarSearch={isFederatedSkilljarSearch}
              isFederatedFreshdeskSearch={isFederatedFreshdeskSearch}
              category={getCategoryId() || undefined}
              isParentCategory={false} // TODO implement this and isParentCategory when extending this feature to category page
              searchByContentType={getContentType()}
              displayFilters={displayFilters}
            />
          </div>
        </div>
      </form>
    )
  }
}
